import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { publishFilter } from '@adornis/baseql/server/context.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet, NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import type { ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { combineLatest, from, switchMap, type Observable } from 'rxjs';
import { ChancenViewProfile } from '../entities/ChancenViewProfile.js';

export const subscribeAllChancenViewProfiles = registerSubscription({
  operationName: 'subscribeAllChancenViewProfiles',
  type: () => [ChancenViewProfile],
  params: [{ type: () => String, name: 'category' }],
  resolve:
    (category: string) =>
    <SelSet extends BaseQLSelectionSet<ChancenViewProfile>>(gqlFields: SelSet) => {
      return combineLatest([
        from(publishFilter(ChancenViewProfile)),
        from(
          CurrentUserInfo.getMyself<ChancenwerkUser>()({
            _id: 1,
            roles: {
              name: 1,
            },
          }),
        ),
      ]).pipe(
        switchMap(([filter, user]) => {
          const selector = {
            category,
            $or: [{ userID: user?._id }, { availableForRoles: { $in: user?.roles.map(r => r.name) } }],
          };
          return watchQuery<ChancenViewProfile>(
            ChancenViewProfile._collectionName,
            filter ? { $and: [filter, selector] } : selector,
            {
              projection: gqlFields,
            },
          ) as unknown as Observable<Array<NarrowedEntity<ChancenViewProfile, SelSet>>>;
        }),
      );
    },
});
